import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { getCsvUrl } from '../utils/csvUrl';
import './Footer.css';

const Footer = () => {
  const { t } = useLanguage();
  const [versionDate, setVersionDate] = useState(null);
  
  useEffect(() => {
    const csvUrl = getCsvUrl();
    
    const formatDate = (d) => {
      if (!d || isNaN(d.getTime())) return null;
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      // Return compact YYYYMMDD format (no dashes)
      return `${yyyy}${mm}${dd}`;
    };
    
    const fetchVersionDate = async () => {
      try {
        // Try HEAD first to avoid downloading the file
        const headResp = await fetch(csvUrl, { method: 'HEAD' });
        const lastMod = headResp.headers.get('Last-Modified');
        if (lastMod) {
          const date = new Date(lastMod);
          const formatted = formatDate(date);
          if (formatted) {
            setVersionDate(formatted);
            return;
          }
        }
        // Fallback to GET if HEAD didn't provide the header
        const getResp = await fetch(csvUrl, { method: 'GET' });
        const lastModGet = getResp.headers.get('Last-Modified');
        if (lastModGet) {
          const date = new Date(lastModGet);
          const formatted = formatDate(date);
          if (formatted) {
            setVersionDate(formatted);
            return;
          }
        }
      } catch (e) {
        // Silently ignore; version will not be shown
      }
    };
    
    fetchVersionDate();
  }, []);
  
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h4 className="footer-heading">{t('about')}</h4>
          <p className="footer-text">
            {t('aboutDescription', 'Mediahuis Tariefcalculator is a tool designed to help you calculate and manage your media planning costs.')}
          </p>
        </div>
        
        <div className="footer-section">
          <h4 className="footer-heading">{t('quickLinks')}</h4>
          <div className="footer-links">
            <Link to="/" className="footer-link">
              {t('products')}
            </Link>
            <Link to="/cart" className="footer-link">
              {t('cart')}
            </Link>
          </div>
        </div>
        
        <div className="footer-section">
          <h4 className="footer-heading">{t('moreInformation')}</h4>
          <div className="footer-links">
            <a href="https://www.mediahuis.nl/tarieven-en-specificaties" target="_blank" rel="noopener noreferrer" className="footer-link">
              {t('ratesAndSpecifications')}
            </a>
            <a href="https://www.mediahuis.nl/aanleverspecificaties" target="_blank" rel="noopener noreferrer" className="footer-link">
              {t('deliverySpecifications')}
            </a>
            <a href="https://www.mediahuis.nl/online-audiences" target="_blank" rel="noopener noreferrer" className="footer-link">
              {t('onlineAudiences')}
            </a>
          </div>
        </div>
        
        <div className="footer-section">
          <h4 className="footer-heading">{t('contact')}</h4>
          <div className="footer-links">
            <a href="mailto:samenwerken@mediahuis.nl" className="footer-link">samenwerken@mediahuis.nl</a>
            <Link to="/about" className="footer-link">
              {t('aboutUs', 'Over ons')}
            </Link>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <div className="copyright">
            © {currentYear} Mediahuis. {t('allRightsReserved')}
            {versionDate ? <span className="footer-version">(v {versionDate})</span> : null}
          </div>
          <img 
            src={`${process.env.PUBLIC_URL}/assets/logo-mediahuis.svg`} 
            alt="Mediahuis Logo" 
            className="footer-logo-mediahuis"
          />
        </div>
      </div>
    </footer>
  );
};

export default Footer; 